export const MP_COVER_TITLE = 'Mad Paws Guarantee';
export const MP_COVER_DESCRIPTION =
  'Every booking made on the platform is backed by the Mad Paws Guarantee, which includes up to $8,000 in vet care for eligible claims.';
export const MP_COVER_LINK = 'https://www.madpaws.com.au/about/mad-paws-accident-cover/';
export const MP_COVER_LEARN_MORE = 'Learn more about the Mad Paws Guarantee';

export const CANCELLATION_POLICY_TITLE = 'Cancellation policy';
export const CANCELLATION_POLICY_LINK =
  'https://madpaws.brainfi.sh/articles/what-is-the-mad-paws-cancellation-and-refund-policy-0dL1b7QXvR';
export const CANCELLATION_POLICY_LEARN_MORE = 'Learn about cancellation';
